export default next => (ctx) => {
  const { method } = ctx
  if (method === 'GET') return next(ctx)

  const { values } = ctx
  if (!values.password) delete values.password

  return next(ctx)
}



// WEBPACK FOOTER //
// ./src/views/middlewares/temp.js